import { defaultAgent, apiResponse } from '../helpers/web-agent';

import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { LOAD_ADDED, LOAD_DELETED, LOAD_NOTES_SAVED } from '../constants/messages';
import {
    SET_SELECTED_LOGISTICS_PLAN, SET_LOGISTICS_REQUESTING, SET_LOGISTICS_HISTORY, SET_LOGISTICS_SEARCH_TEXT, SET_LOGISTICS_DETAIL, SET_LOGISTICS_SELECTED_IDS, SET_FILTERED_LOGISTICS_HISTORY,
    SET_LOGISTIC_VARIETY_DETAILS, SET_LOGISTIC_SUPPLIER_DETAILS, REMOVE_LOGISTIC_LOADS, UPDATE_LOGISTIC_LOAD, SET_LOGISTIC_BULK_EDIT, SET_EDITED_LOGISTIC_HISTORY, SET_SELECTED_LOGISTIC_LOAD_ID,
    SET_LOGISTIC_DISCARD, UPDATE_LOGISTIC_PAYLOAD, SET_ALL_LOGISTICS_PLAN, SET_LOGISTIC_TIMELINE, SET_LOGISTIC_TIMELINE_REQUESTING, SET_LOGISTIC_LOT_DETAILS, SET_LOGISTICS_TARE_REQUESTING, 
    SET_LOGISTICS_TARE_HISTORY,
    UPDATE_LOGISTICS_TARE_LOAD,
    SET_LOGISTICS_SEED_TYPE_DETAILS,
    SET_LOGISTICS_SEED_CUTTING_GROUP
} from '../constants/action-types';

export const setLogisticsRequesting = () => ({ type: SET_LOGISTICS_REQUESTING });

export const setLogisticsHistory = payload => ({ type: SET_LOGISTICS_HISTORY, payload });

export const setPlanType = payload => ({ type: SET_SELECTED_LOGISTICS_PLAN, payload });

export const setSelectAllPlan = payload => ({ type: SET_ALL_LOGISTICS_PLAN, payload });

export const setSearchText = searchText => ({ type: SET_LOGISTICS_SEARCH_TEXT, searchText });

export const setLogisticsDetail = payload => ({ type: SET_LOGISTICS_DETAIL, payload });

export const setFilterIds = payload => ({ type: SET_LOGISTICS_SELECTED_IDS, payload });

export const setFilteredHistory = payload => ({ type: SET_FILTERED_LOGISTICS_HISTORY, payload });

export const setLogisticsVariety = payload => ({ type: SET_LOGISTIC_VARIETY_DETAILS, payload });

export const setLogisticsLot = payload => ({ type: SET_LOGISTIC_LOT_DETAILS, payload });

export const setsupplier = payload => ({ type: SET_LOGISTIC_SUPPLIER_DETAILS, payload });

export const setLogisticsSeedType = payload => ({ type: SET_LOGISTICS_SEED_TYPE_DETAILS, payload });

export const setLogisticsSeedCutingGroup = payload => ({ type: SET_LOGISTICS_SEED_CUTTING_GROUP, payload });

export const removeLogisticsLoads = payload => ({ type: REMOVE_LOGISTIC_LOADS, payload });

export const updateLogisticsLoad = (loadId, data) => ({ type: UPDATE_LOGISTIC_LOAD, loadId, data });

export const setBulkEdit = payload => ({ type: SET_LOGISTIC_BULK_EDIT, payload });

export const setEditedLogisticsHistory = payload => ({ type: SET_EDITED_LOGISTIC_HISTORY, payload });

export const setSelectedIds = payload => ({ type: SET_SELECTED_LOGISTIC_LOAD_ID, payload });

export const setLogisticsDiscard = () => ({ type: SET_LOGISTIC_DISCARD });

export const updatePayload = () => ({ type: UPDATE_LOGISTIC_PAYLOAD });

export const setTimeLineRequesting = () => ({ type: SET_LOGISTIC_TIMELINE_REQUESTING });

export const setTimeLine = payload => ({ type: SET_LOGISTIC_TIMELINE, payload });

export const setLogisticsTareRequesting = () => ({ type: SET_LOGISTICS_TARE_REQUESTING });

export const setLogisticsTareHistory = payload => ({ type: SET_LOGISTICS_TARE_HISTORY, payload });

export const updateLogisticsTareLoad = payload => ({ type: UPDATE_LOGISTICS_TARE_LOAD, payload });

export const getLogisticsVariety = farmId => dispatch => {
    defaultAgent.get(`api/logistics/variety-name`, { farm_uuid: farmId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
            else if (agentResult.data) dispatch(setLogisticsVariety(agentResult.data));
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(ex.message);
        });
};

export const getLogisticsSupplier = farmId => dispatch => {
    defaultAgent.get(`api/logistics/supplier`, { farm_uuid: farmId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
            else if (agentResult.data) dispatch(setsupplier(agentResult.data));
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(ex.message);
        });
};

export const getLogisticsLot = farmId => dispatch => {
    defaultAgent.get(`api/logistics/lots`, { farm_uuid: farmId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
            else if (agentResult.data) dispatch(setLogisticsLot(agentResult.data));
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(ex.message);
        });
};

export const getLogisticsSeedType = farmId => dispatch => {
    defaultAgent.get(`api/logistics/seed-type`, { farm_uuid: farmId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
            else if (agentResult.data) dispatch(setLogisticsSeedType(agentResult.data));
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(ex.message);
        });
};

export const getLogisticsSeedCuttingGroup = farmId => dispatch => {
    defaultAgent.get(`api/logistics/seed-cutting-group`, { farm_uuid: farmId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
            else if (agentResult.data) dispatch(setLogisticsSeedCutingGroup(agentResult.data));
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(ex.message);
        });
};

export const setSelectedPlanType = id => dispatch => {
    if (!id) return;
    dispatch(setPlanType(id));

    defaultAgent.put(`api/user/settings/update`, { plan_type_id: id })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Reported Date: ', ex.message);
        });
};

export const setSelectAll = id => dispatch => {
    if (!id) return;
    dispatch(setPlanType(id));

    defaultAgent.put(`api/user/settings/update`, { plan_type_id: id })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Reported Date: ', ex.message);
        });
};

export const getLogisticsHistory = params => dispatch => {
    dispatch(setLogisticsRequesting());

    defaultAgent.get('api/logistics/load/history', params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(setLogisticsHistory([]));
            dispatch(tokenExpired());
        }
        else if (agentResult.data) dispatch(setLogisticsHistory(agentResult.data));
        else if (agentResult.message) {
            dispatch(setLogisticsHistory([]));
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(setLogisticsHistory([]));
        dispatch(toastError(ex.message));
    });
};

export const addLogisticsLoad = (params, cb) => dispatch => {
    defaultAgent.post(`/api/logistics/load/add`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_ADDED.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const editLogisticsLoad = (params, cb) => dispatch => {
    defaultAgent.put(`api/logistics/load/edit`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true, params);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const saveLogisticsNotes = (params, cb) => dispatch => {
    defaultAgent.put(`api/logistics/load/notes/save`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_NOTES_SAVED.code) {
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const deleteLoad = (params, cb) => dispatch => {
    defaultAgent.put(`api/logistics/load/delete`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === LOAD_DELETED.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
}

export const bulkEditLogisticsLoad = (params, cb) => dispatch => {
    defaultAgent.put(`api/logistics/load/edit/bulk`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const getLogisticsTimeLine = params => dispatch => {
    dispatch(setTimeLineRequesting());

    defaultAgent.get('api/logistics/load/timeline', params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(setTimeLine([]));
            dispatch(tokenExpired());
        }
        else if (agentResult.data) dispatch(setTimeLine(agentResult.data));
        else if (agentResult.message) {
            dispatch(setTimeLine([]));
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(setTimeLine([]));
        dispatch(toastError(ex.message));
    });
};

export const getLogisticsTareLoad = (params, cb) => dispatch => {    
    dispatch(setLogisticsTareRequesting());
    const { farm_uuid, include_events, range_type, from_date, to_date, is_tareload } = params;
    let reqParams = { farm_uuid, include_events, range_type, from_date, to_date, is_tareload };

    defaultAgent.get(`api/logistics/load/history`, reqParams)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(setLogisticsTareHistory());
                if (cb) cb();
            } else if (agentResult.data) {
                dispatch(setLogisticsTareHistory(agentResult.data));
                if (cb) cb(agentResult.data);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Total Trip: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(setLogisticsTareHistory());
            if (cb) cb();
        });
};